import { EvolutionItem, Hospitalisation, SummaryData } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { formatDate, getItemId } from "@/src/utils/utils";
import { getAnswersText, getAntecedentsText } from "./textGenerationUtils";
import { evolutionItemTypes } from "@/src/data/data";

export async function generateHospitalisationSummaryHtml({
    summaryData,
  }: {
    summaryData: SummaryData;
  }): Promise<string> {
    console.log({ summaryData });
    let parent = summaryData.item as Hospitalisation;
    if (!parent) return "";
    let patient = parent.patient;
    if (!patient) return "";
  
    function getMotivesText() {
      return parent.motives?.map((motive) => motive?.reference?.name).join(", ");
    }
  
    function getDiagnosticsText() {
      return parent.diagnostics
        ?.map((diagnostic) => diagnostic?.reference?.name)
        .join(", ");
    }
  
    async function getLastStoryText() {
      let lastStory = await apiFetch("stories", "loadLast", {
        patientId: getItemId(patient),
        parentId: null,
      });
  
      return `${lastStory?.notes || ""} \n ${lastStory?.conclusion || ""}`;
    }
  
    async function getEvolutionItemsText() {
      return summaryData.evolutionItems
        ?.map((item) => getEvolutionItemText(item))
        ?.join("\n\n");
    }
  
    function getEvolutionItemText(item: EvolutionItem | null | undefined) {
      if (!item) return "";
      let physicalSignsText = "";
      let functionalSignsText = "";
      if (item.type == "admission" || item.type == "evolution") {
        physicalSignsText = (
          item.physicalSigns?.map((sign) => {
            return `- ${sign?.reference?.name}: ${getAnswersText(
              sign?.fieldAnswers
            )}`;
          }) || []
        ).join(", ");
  
        functionalSignsText = (
          item.functionalSigns?.map((sign) => {
            return `- ${sign?.reference?.name}: ${getAnswersText(
              sign?.fieldAnswers
            )}`;
          }) || []
        ).join(", ");
      }
  
      let evolutionItemType = evolutionItemTypes[item.type];
      return `<strong>${evolutionItemType.name} - ${item._date}</strong>\n
      ${item.notes || ""}\n
      ${physicalSignsText || ""}\n
      ${functionalSignsText || ""}\n
      <strong>${(item as any).conclusion || ""}</strong>\n`;
    }
  
    function getExamsText() {
      return summaryData.exams
        ?.map((exam) => {
          return `<strong>${exam.reference?.name} - ${exam._date}</strong>\n 
                ${getAnswersText(exam?.content?.fieldAnswers)} \n 
                <strong>${exam.conclusion}</strong>`;
        })
        .join("\n\n");
    }
  
    async function getTreatment(): Promise<string> {
      let ordonnances = await apiFetch(
        "ordonnances",
        "loadMany",
        {
          categories: ["hospital"],
          patientId: getItemId(patient),
          parentId: getItemId(parent),
        },
        "Erreur lors du chargement des ordonnances"
      );
  
      let medicineTexts: Record<string, string> = {};
      console.log("ordonnances", ordonnances);
  
      for (let ordonnance of ordonnances) {
        for (let ordonnanceMedicine of ordonnance.ordonnanceMedicines) {
          if (!ordonnanceMedicine) continue;
          const { medicine, startDate, endDate, duration } = ordonnanceMedicine;
          if (!medicine) continue;
          let medicineId = medicine?.id;
          if (!medicineId) continue;
          medicineTexts[medicineId] ||= `<strong>${medicine.name}</strong>\n`;
  
          let intakesText = ``;
          for (let intake of ordonnanceMedicine?.intakes || []) {
            if (!intake) continue;
            const { unit, posology, route, horaire, notes } = intake;
            intakesText += `${posology} ${unit || ""} par voie ${route || ""} à ${
              horaire || ""
            } ${notes || ""} \n`;
          }
  
          medicineTexts[medicineId] += `
          ${intakesText} 
          du ${formatDate(startDate, "LL")} au ${formatDate(
            endDate,
            "LL"
          )} \n (${duration})
          `;
        }
      }
  
      return Object.values(medicineTexts).join("\n\n");
    }
  
    return `
    <strong>Motif d'hospitalisation:</strong>\n
    <strong>${getMotivesText()}</strong>\n\n\n
  
    <strong class="bold">FDR / Antécédents: </strong>\n\n
    ${await getAntecedentsText({ patient })}\n
    \n\n\n\n
  
    <strong class="bold">Histoire de la maladie: </strong>\n
    ${await getLastStoryText()}\n
    \n\n\n\n
  
    <strong class="bold">Evolution dans le service: </strong>\n
    ${await getEvolutionItemsText()}\n
    \n\n\n\n
  
    <strong class="bold">Examens réalisés: </strong>\n
    ${getExamsText()}\n
    \n\n\n\n
  
    <strong>Traitement intra-hospitalier: </strong>\n 
    ${await getTreatment()}\n
    \n\n\n
    
    <strong>Traitement à la sortie: </strong>\n
    \n\n\n

  
    <strong>Conclusion: </strong>\n
    ${summaryData.conclusion || ""}\n
    \n\n\n
    \n\n\n
  
  
  <div class="fright" style="margin-right:25px;">
    Signature de l'assistant responsable
    \n\n\n
    \n\n\n
    \n\n\n
  </div>`;
  }
  